import React, {Component} from 'react'
import {Modal, Row} from 'antd'
import SalikForm from '../../../../../components/Operations/Transport/Management/Salik/SalikForm'

class SalikModal extends Component {
  render() {
    const {
      visibleSalik,
      onCancelSalik,
      onSalikUpload,
      salikFormRef,
      submittingSalik,
    } = this.props
    return (
      <Modal
        visible={visibleSalik}
        title={'Confirm Salik'}
        onCancel={onCancelSalik}
        onOk={onSalikUpload}
        okText={'Upload'}
        destroyOnClose={true}
        confirmLoading={submittingSalik}
        width={999}>
        <Row>
          <SalikForm ref={salikFormRef} {...this.props} />
        </Row>
      </Modal>
    )
  }
}

SalikModal.propTypes = {}
SalikModal.defaultProps = {}

export default SalikModal
